import React, { FC, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import "./ResultatPage.css";
import { AuthService } from "../services/AuthService";
import { AccountService } from "../services/AccountService";

interface Props {}

const Resultat: FC<Props> = () => {
    const history = useHistory();
    const [dialogVisible, setDialogVisible] = useState(false);
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const authService = new AuthService();
    const accountService = new AccountService();

    const handleFinish = async () => {
        const driver = authService.getUser();
        setDialogVisible(false);

        if (!driver) {
            return;
        }

        setLoading(true);
        try {
            const response = await accountService.SendCertificateToDriver(driver.email);

            if (response.data.message === "Certificat envoyé au chauffeur et transporteur notifié avec succès") {
                localStorage.clear();
                history.push("/");       
            } else {
                setError(response.data.message);
                setDialogVisible(true);
                console.error('Échec de l\'envoi du certificat');
            } 
        } catch (error) {
            setError(error);
            setDialogVisible(true);
            console.error('Erreur lors de l\'envoi du certificat:', error);
        } finally {
            setLoading(false);
        }
    };

    const onHide = () => {
        setDialogVisible(false);
        localStorage.clear();
        history.push("/");
    };

    return (
        <div className="result-container flex flex-col items-center justify-center mx-auto min-h-screen p-4 sm:p-6 md:p-8">
            <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                    className="result-banner w-full h-48 sm:h-64 md:h-80 object-cover" 
                    src="https://prodrive-uploads.s3.eu-west-3.amazonaws.com/group-of-young-male-and-female-worker-working-in-container.jpg" 
                    alt="Bannière de succès" 
                />
                <div className="result-message p-6 sm:p-8 md:p-10 text-center">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">Félicitations !</h2>
                    <p className="text-lg sm:text-xl mb-4">Vous avez réussi le test de certification avec succès.</p>
                    <p className="text-base sm:text-lg mb-4">Cliquez sur le bouton ci-dessous pour recevoir votre certificat par e-mail et terminer le processus.</p>
                    <p className="text-base sm:text-lg mb-6">Merci pour votre participation !</p>
                    <Button 
                        label={`Terminer et recevoir le certificat`} 
                        className="btn-primary text-base sm:text-lg p-3 sm:p-4"
                        onClick={handleFinish}
                        loading={loading}
                        disabled={loading}
                    />
                </div>
            </div>
            <Dialog
                visible={dialogVisible}
                onHide={onHide}
                header="Erreur"
                breakpoints={{ "960px": "75vw", "640px": "100vw" }}
                style={{ width: "50vw" }}
                showHeader={false}
                contentClassName="bg-white rounded-lg shadow-lg p-4 sm:p-8"
            >
                <div className="text-base sm:text-lg font-sans">
                    <p className="mb-4">Il y a eu une erreur lors de l'envoi du certificat, merci de vérifier votre connexion internet et réessayer.</p>
                    <p className="mb-4">Si le problème persiste, veuillez contacter votre transporteur et attacher l'erreur ci-dessous.</p>
                    <p className="p-2 bg-red-200 text-red-700 rounded-lg mt-4 text-center font-semibold">{error?.message}</p>
                    <div className="flex justify-center gap-4 max-h-16 mt-4">
                        <button className="btn-primary text-base sm:text-lg p-2 sm:p-3 w-1/2" onClick={handleFinish}>Réessayer</button>
                        <button className="btn-primary text-base sm:text-lg p-2 sm:p-3 w-1/2" onClick={onHide}>Terminer</button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default Resultat;
